module.exports = __webpack_public_path__ + "static/media/android-integration.b7611392.md";